import { getOrderVouchers } from './get-order-vouchers';
export const getOrderVoucherById = (id) => {
    const voucher = getOrderVouchers().find(v => v.id === id);
    if (!voucher)
        throw new Error(`Cannot find voucher with ID: ${id}.`);
    return voucher;
};
